import ServerError from "@modules/ServerError/ServerError";

export default function ServerTimeout() {
  return <ServerError statusCode={504} />;
}
